module.exports = __webpack_public_path__ + "img/73.05836d2b.jpg";